import { useLocation, Link } from "@/lib/router-compat";
import { useEffect } from "react";

const HELPFUL_LINKS = [
  { to: "/", label: "Home" },
  { to: "/guides", label: "Homebuying guides" },
  { to: "/blog", label: "Blog" },
  { to: "/tools", label: "Tools and calculators" },
  { to: "/grant-finder", label: "Down payment assistance finder" },
];

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted px-4">
      {/*
        The 404 status is what actually keeps a missing URL out of search indexes (Google ignores
        the body of 4xx responses). This tag is belt and suspenders for crawlers that read an error
        body anyway. React 19 hoists it into the document head, including on the server, whereas
        PageMeta sets head tags only after hydration. "follow" is the default, so it is not repeated.
      */}
      <meta name="robots" content="noindex" />
      <div className="max-w-md text-center">
        <h1 className="mb-2 text-4xl font-bold">404</h1>
        <p className="mb-2 text-xl text-foreground">We couldn't find that page</p>
        <p className="mb-6 text-sm text-muted-foreground">
          It may have moved or been removed. These pages are a good place to pick up where you left
          off.
        </p>
        <ul className="space-y-2">
          {HELPFUL_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="text-primary underline hover:text-primary/90">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default NotFound;
